// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-report-templates {\n  height: 100%;\n  position: relative;\n}\n@media (max-width: 1200px) {\n  .custom-report-templates .form-col,\n  .custom-report-templates .preview-col {\n    width: 100%;\n  }\n}\n@media (max-width: 768px) {\n  .custom-report-templates .preview-col {\n    display: none;\n  }\n}\n.custom-report-templates .step-counter {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
